const STORAGE_KEY = 'chapter.admin.user_role_override';
const EVENT_NAME = 'chapter-admin-role-override-changed';

export const HESOYAM_KEY_CODES = ['KeyH', 'KeyE', 'KeyS', 'KeyO', 'KeyY', 'KeyA', 'KeyM'];

const hasWindow = () => typeof window !== 'undefined';

const normalizeOverride = (value) => {
  if (!value || typeof value !== 'object') return null;
  if (typeof value.is_superuser !== 'boolean' || typeof value.is_admin !== 'boolean') return null;
  return {
    is_superuser: value.is_superuser,
    is_admin: value.is_admin
  };
};

const emitOverrideEvent = () => {
  if (!hasWindow()) return;
  window.dispatchEvent(new CustomEvent(EVENT_NAME));
};

export const getUserRoleOverride = () => {
  if (!hasWindow()) return null;
  try {
    const rawValue = window.localStorage.getItem(STORAGE_KEY);
    if (!rawValue) return null;
    const parsedValue = JSON.parse(rawValue);
    return normalizeOverride(parsedValue);
  } catch (error) {
    return null;
  }
};

export const setUserRoleOverride = (override) => {
  if (!hasWindow()) return;
  const normalized = normalizeOverride(override);
  if (!normalized) return;
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(normalized));
  emitOverrideEvent();
};

export const clearUserRoleOverride = () => {
  if (!hasWindow()) return;
  window.localStorage.removeItem(STORAGE_KEY);
  emitOverrideEvent();
};

export const applyUserRoleOverride = (user) => {
  if (!user) return user;

  const override = getUserRoleOverride();
  const baseIsAdmin = String(user.username || '').toLowerCase() === 'admin';

  if (!override) {
    const rest = { ...user };
    delete rest.__local_role_override;
    delete rest.__local_is_admin;
    return {
      ...rest,
      __local_role_override: false,
      __local_is_admin: baseIsAdmin
    };
  }

  return {
    ...user,
    is_superuser: override.is_superuser,
    __local_role_override: true,
    __local_is_admin: override.is_admin
  };
};

export const isUserAdminForUi = (user) => {
  if (!user) return false;
  if (user.__local_role_override) {
    return Boolean(user.__local_is_admin);
  }
  return String(user.username || '').toLowerCase() === 'admin';
};

export const getRoleOverrideEventName = () => EVENT_NAME;
